<template>
  <div>
    <div v-if="detail" style="margin-bottom: 10px;padding: 5px;">
      <div>
        书名:{{ detail.share.bookName }}
      </div>
      <div>
        在售:{{ detail.product.prodNum }} ~ 购买人数:{{ detail.boughtInfo.number }}
      </div>
      <div>
        购买指数:{{ score }} ~ 购入数量:<a href="#" size="mini" @click="show = true">{{ order_num }}</a> ~ 出售数量:{{ sold_num }} ~
        丢失数量:{{ lose_num }}
      </div>
      <div>
        三个月销量:{{ three_month_sold_num }}
      </div>
      <div>
        孔夫子市场价:{{ kfz_market_price }}
      </div>
      <div>
        孔夫子成本价:{{ cost_price }}
      </div>
      <div>
        孔夫子最低价:{{ old_book_price }}
      </div>
      <div>
        多抓鱼价格:{{ dzy_price }}~{{ dzy_newConditionPrice }}
      </div>
      <a v-if="is_windows" :href="'https://item.kongfz.com/book/' + form.k_id + '_0_4_1.html'" size="mini"
        target="_blank">查看商品主页</a>
      <a v-else :href="'https://m.kongfz.com/item/' + form.k_id" size="mini">查看商品主页</a>
      <div><a target="_blank" :href="'http://www.sffdgdf.jiaowushu.com/purchase/order?isbn=' + form.isbn"
          style="margin-top: 10px;">查看库存</a></div>
      <div><a @click="showStep = true">查看历史价</a></div>
      <van-checkbox v-model="form.checked" @change="changeChecked">是否隐藏拉黑商品</van-checkbox>
    </div>
    <van-tabs v-model="active" @change="change">
      <van-tab title="在售"></van-tab>
      <van-tab title="九上在售"></van-tab>
      <van-tab title="九五上在售"></van-tab>
      <van-tab title="售罄"></van-tab>
      <van-tab title="九上售罄"></van-tab>
    </van-tabs>

    <van-popup v-model="show" position="bottom" :style="{ height: '80%' }" round>
      <van-card v-for="item in order_list" :key="item.id" :price="item.actualPaid / 100"
        :desc="'出售价：' + item.all_amount" :title="item.title" thumb="https://img01.yzcdn.cn/vant/ipad.jpeg">
        <div slot="tags">
          <span v-for="(item_reason, index) in item.flawReasons" :key="index">
            <van-tag type="danger" v-if="item_reason === 'marks'"> 有划线或标注</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'lightly_dirty'"> 轻度污渍</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'lightly_mildew'"> 轻度发霉</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'lightly_breakage'"> 轻度破损</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'lightly_scratched'"> 轻度划破</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'lightly_folded'"> 折痕</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'lightly_deform'"> 变形</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'aging'"> 泛黄或褪色</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'cover_lost'"> 可拆卸外封套缺失</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'attachment_lost'"> 缺失附件</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'quality_issues'"> 印刷问题</van-tag>
            <van-tag type="danger" v-else-if="item_reason === 'non-removable_labels'"> 附着胶带或标签</van-tag>
          </span>
          <span v-if="item.sold_status === 1">
            <van-tag> 利润：{{ item.all_amount - item.price / 100 - (item.all_amount - 15) * 0.05 }} </van-tag>
            <van-tag> 利润率：{{ (item.all_amount - item.price / 100 - (item.all_amount - 15) * 0.05) / item.all_amount *
              100
            }}% </van-tag>
          </span>
          <span v-if="item.sold_status === 1">
            <van-tag type="primary" style="margin:2px"> 留存天数:{{ item.time_difference }}</van-tag>
            <van-tag type="primary" style="margin:2px"> 销售天数:{{ item.time_sold_difference }}</van-tag>
          </span>
          <span v-if="item.sold_status === 0">
            <van-tag type="primary" style="margin:2px"> 留存天数:{{ item.diffInDays }}</van-tag>
            <van-tag type="primary" v-if="item.publish_at" style="margin:2px"> 发布天数:{{ item.publish_diffInDays
            }}</van-tag>
            <van-tag type="primary" v-if="item.edit_at && item.publish_at" style="margin:2px"> 修改天数:{{
              item.time_edit_difference }}</van-tag>
          </span>
          <van-tag type="success" style="margin:2px"> 购买:{{ item.created }}</van-tag>
          <van-tag type="success" v-if="item.confirm_at" style="margin:2px"> 确认:{{ item.confirm_at }}</van-tag>
          <van-tag type="success" v-if="item.publish_at" style="margin:2px"> 发布:{{ item.publish_at }}</van-tag>
          <van-tag type="success" v-if="item.sold_at" Dstyle="margin:2px"> 出售:{{ item.sold_at }}</van-tag>
        </div>
        <template slot="footer" v-if="!item.sold_status">
          <van-button type="info" round size="mini"
            @click="showSoldDialog = true, currentItem = item, currentItem.all_amount = currentPrice, currentItem.type = 'price'">改价</van-button>
        </template>
        <div slot="tag">
          <van-tag type="danger" v-if="item.sold_status === 1"> 已出售</van-tag>
          <van-tag type="success" v-else> 在售</van-tag>
        </div>
      </van-card>

    </van-popup>

    <van-popup v-model="showStep" position="bottom" :style="{ height: '80%' }" round>
      <van-steps direction="vertical" :active="0">
        <van-step v-for="(item, index) in historyPriceList" :key="index">
          <h3>当前价格：{{ item.dzy_price / 100 }}元，变化：<span :style="item.change < 0 ? 'color:red' : 'color:#07c160'">{{
            item.change / 100 }}元</span></h3>
          <p>{{ item.date }}</p>
        </van-step>
      </van-steps>
    </van-popup>

    <!--   <van-popup v-model="showStepPic" position="bottom" :style="{ height: '80%' }" round>
      <van-swipe >
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img v-lazy="image" width="100%"/>
        </van-swipe-item>
      </van-swipe>
    </van-popup> -->

    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-for="(item, index) in list" :key="index" :class="{ 'van-card--highlight': highlightShopIds.has(String(item.shopId)) }" class="van-card-wrap">
        <van-card :tag="item.quality" :price="item.price"
          :desc="'店铺:' + item.shopName" :title="item.itemName" :thumb="item.smallImg"
          @click-thumb="productDetail(item.shopId, item.itemId)">
        <template slot="tags">
          <van-tag v-if="item.importantDesc" plain type="danger">商品描述:{{ item.importantDesc }}</van-tag>
          <van-tag type="success"> {{ item.xinYuTags[0] }}</van-tag>
          <van-tag type="success" style="margin:2px"> {{ item.xinYuTags[1] }}</van-tag>
          <van-tag v-if="active > 2" plain type="danger">售罄:{{ item.soldTime }}</van-tag>
          <van-tag v-else plain type="success">上架:{{ item.date }}</van-tag>
          <van-tag plain type="success" style="margin-left:8px">{{ item.diff_days }}天</van-tag>
        </template>
        <template slot="footer">
          <a v-if="item.shopId != 785871 && item.shopId != 771124 && item.shopId != 729330" href="#" size="mini"
            @click.prevent="addProductToBlacklist(item)">拉黑</a>
          <a style="margin-left: 10px;cursor: pointer;" @click.prevent="selectThisPrice(item.price)"
            size="mini">选用价格</a>
          <a v-if="is_windows" target="_blank" style="margin-left: 10px;"
            :href="'https://book.kongfz.com/' + item.shopId + '/' + item.itemId + '/'" size="mini">查看商品</a>
          <a v-else :href="'https://mbook.kongfz.com/' + item.shopId + '/' + item.itemId + '/'"
            style="margin-left: 10px;" size="mini">查看商品</a>
          <span v-if="item.shopId">
            <a v-if="is_windows" target="_blank" style="margin-left: 10px;"
              :href="'https://shop.kongfz.com/' + item.shopId">查看店铺</a>
            <a v-else style="margin-left: 10px;" :href="'https://m.kongfz.com/newshop/' + item.shopId">查看店铺</a>
          </span>
        </template>
      </van-card>
      </div>
    </van-list>

    <van-dialog v-model="showSoldDialog" title="修改出售价" show-cancel-button @confirm="updatePrice">
      <van-field v-model="currentItem.all_amount" label="出售总价" placeholder="请输入出售总价" />
      <div style="margin: 15px 10px;">
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;"
          @click="updateAllAmount(-5)">-5元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;"
          @click="updateAllAmount(-2)">-2元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;"
          @click="updateAllAmount(-1)">-1元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;"
          @click="updateAllAmount(1)">+1元</van-button>
        <van-button type="primary" size="small" style="padding: 0 10px; margin:0px 6px ;"
          @click="updateAllAmount(2)">+2元</van-button>
      </div>
    </van-dialog>
    <van-image-preview v-model="showStepPic" :images="images" :closeable="true" @change="onChange">
      <template v-slot:index>第{{ index }}页</template>
    </van-image-preview>

  </div>
</template>

<script>

export default {
  name: 'Book',
  data () {
    return {
      images: [
        'https://via.placeholder.com/600x400/ff7f7f/333333?text=Image1',
        'https://via.placeholder.com/600x400/7fff7f/333333?text=Image2',
        'https://via.placeholder.com/600x400/7f7fff/333333?text=Image3'
      ],
      initialIndex: 0,
      option1: [
        { text: '全部品相', value: 0 },
        { text: '全新', value: 1 },
        { text: '九五品以上', value: 11 },
        { text: '九品以上', value: 9 },
        { text: '八五品以上', value: 10 },
        { text: '八品以上', value: 8 },
        { text: '七品以上', value: 7 },
        { text: '六品以上', value: 6 },
        { text: '五品以上', value: 5 },
        { text: '四品及以下', value: 4 }
      ],
      option2: [
        { text: '全部品相', value: '' },
        { text: '全新', value: '100' },
        { text: '九五品以上', value: '95h' },
        { text: '九品以上', value: '90h' },
        { text: '八五品以上', value: '85h' },
        { text: '八品以上', value: '80h' },
        { text: '七品以上', value: '70h' }
      ],
      active: 0,
      order_num: 0,
      is_windows: 0,
      three_month_sold_num: 0,
      cost_price: 0,
      old_book_price: 0,
      kfz_market_price: 0,
      score: 0,
      order_no: '',
      dzy_id: '',
      list: [],
      order_list: [],
      historyPriceList: [],
      detail: null,
      showSoldDialog: false,
      show: false,
      showStep: false,
      showStepPic: false,
      currentItem: {},
      currentPrice: null,
      loading: false,
      finished: false,
      index: 0,
      form: {
        isbn: '',
        quality: '',
        checked: true,
        type: 0,
        page_no: 0
      },
      // 需要高亮背景的店铺 ID 集合
      highlightShopIds: new Set([
        25632, 842596, 892270, 887808, 884893, 1185864, 690197, 876979, 907956, 885849, 5084, 175304, 795093,
        205781, 209758, 239093, 242348, 245724, 247696, 259625, 261676, 265425, 269228, 273980, 274410, 274596,
        275309, 277989, 281368, 282447, 284518, 287213, 292306, 307893, 320086, 275954, 322133, 333393, 333795,
        343116, 352560, 356104, 362089, 369703, 374786, 381544, 398292, 403896, 410675, 415117, 419594, 427434,
        428100, 433211, 434686, 456924, 459014, 460548, 472926, 481768, 487168, 487225, 495963, 501170, 503741,
        508461, 513430, 514238, 514641, 515521, 527299, 531858, 533871, 560422, 562676, 563159, 566861, 568773,
        568955, 569071, 575065, 576178, 576963, 578299, 581986, 584009, 585045, 587343, 588737, 589624, 591717,
        592438, 593893, 593972, 594145, 596762, 602162, 604658, 606759, 622854, 623571, 636232, 637994, 643379,
        649516, 649567, 649993, 658219, 660157, 660905, 661883, 664650, 665817, 668567, 669791, 669845, 670859,
        672618, 673562, 677831, 678018, 679167, 680603, 691137, 691159, 692115, 709485, 710549, 712744, 713685,
        717174, 721532, 724881, 726495, 726711, 727326, 732541, 734345, 741796, 742497, 751395, 754652, 756281,
        759402, 761612, 762752, 782454, 787766, 788819, 792783, 796362, 797012, 798362, 799862, 812431, 813277,
        815170, 817504, 821139, 825407, 839397, 845752, 847152, 879722, 879864, 881523, 883028, 885102, 888673,
        891652, 893765, 895529, 895633, 899353, 899862, 901511, 906858, 906860, 910239, 912243, 919010, 1088581,
        1093668, 1096333, 1099922, 1124856, 1126359, 1127958, 1156785, 1157780, 1158864, 1160129, 1160295, 1160782,
        1160797, 1180666, 1186612, 1187540, 1187970, 1190666, 1207088, 1208551, 1209315, 1213267, 1214279, 1219241,
        26986, 336780, 910428, 157107, 600769
      ].map(String))
    }
  },
  mounted () {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  created () {
    var userAgent = navigator.userAgent.toLowerCase()
    console.log(userAgent)
    if (userAgent.indexOf('windows') !== -1) {
      this.is_windows = 1
    } else {
      this.is_windows = 0
    }

    this.form.page_no = 0
    this.form.isbn = this.$route.query.isbn
    this.form.dzy_id = this.$route.query.dzyid
    this.form.keyword = this.$route.query.isbn
    this.onLoad()
    this.detailItem()
    this.myOrderRecord()
    this.getHistoryPrice()
  },
  methods: {
    updateAllAmount (price) {
      this.currentItem.all_amount = parseFloat(this.currentItem.all_amount) + price
    },
    selectThisPrice (price) {
      this.currentPrice = price
      sessionStorage.setItem('currentPrice', price)
      this.$store.commit('setCurrentPrice', price)
    },
    handleKeydown (event) {
      if (event.key === 'ArrowLeft') {
        this.initialIndex = this.initialIndex - 1
        if (this.initialIndex === -1) this.initialIndex = this.images.length - 1
        this.$preview(this.initialIndex, this.images)
      } else if (event.key === 'ArrowRight') {
        this.initialIndex = this.initialIndex + 1
        if (this.initialIndex === this.images.length) this.initialIndex = 0
        this.$preview(this.initialIndex, this.images)
      } else if (event.keyCode === 32) { // Space bar key code
        this.initialIndex = this.initialIndex + 1
        if (this.initialIndex === this.images.length) this.initialIndex = 0
        this.$preview(this.initialIndex, this.images)
      }
    },
    onChange (index) {
      this.index = index
    },
    changeChecked (checked) {
      console.log(checked)
      this.form.checked = checked ? 1 : 0
      this.change()
    },
    async onLoad () {
      this.loading = true
      this.form.page_no = this.form.page_no + 1
      let url = ''
      if (this.active === 0) {
        this.form.type = 0
        url = 'kfz/product/getItemList'
      }
      if (this.active === 1) {
        this.form.type = 9
        url = 'kfz/product/getItemList'
      }
      if (this.active === 2) {
        this.form.type = 11
        url = 'kfz/product/getItemList'
      }
      if (this.active === 3) {
        this.form.quality = ''
        url = 'kfz/product/productSearchV2'
      }
      if (this.active === 4) {
        this.form.quality = '90h'
        url = 'kfz/product/productSearchV2'
      }
      const { data: res } = await this.$http.post(url, this.form)
      if (res.status === 1) {
        this.list = this.list.concat(res.data.itemList)
        this.list = this.list.map(item => ({ ...item, isHidden: false }))
        res.data.itemList.length === 100 ? this.loading = false : this.loading = true
      } else {
        this.finished = true
      }
    },
    async productDetail (shopId, itemId) {
      this.images = []
      const url = 'kfz/product/detail?shopId=' + shopId + '&itemId=' + itemId
      const { data: res } = await this.$http.get(url)
      if (res.status === 1) {
        console.log(res)
        this.initialIndex = 0
        this.images = res.data
        if (this.is_windows === 0) this.showStepPic = true
        else this.$preview(0, this.images)
      }
    },
    async detailItem () {
      const url = 'kfz/product/detailItem'
      const { data: res } = await this.$http.post(url, this.form)
      if (res.status === 1) {
        this.form.k_id = res.k_id
        this.score = res.score
        this.sold_num = res.sold_num
        this.lose_num = res.lose_num
        this.order_num = res.buy_num
        this.kfz_market_price = res.kfz_market_price
        this.old_book_price = res.old_book_price
        this.cost_price = res.cost_price
        this.three_month_sold_num = res.three_month_sold_num
        this.dzy_newConditionPrice = res.dzy_newConditionPrice
        this.dzy_price = res.dzy_price
        this.detail = res.data
      }
    },
    async getHistoryPrice () {
      const url = 'dzy/price/list'
      const { data: res } = await this.$http.post(url, this.form)
      if (res.code === 200) {
        this.historyPriceList = res.data
      }
    },
    async addProductToBlacklist (item) {
      // 记录当前滚动位置
      // const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const url = 'kfz/product/addProductToBlacklist?item_id=' + item.itemId
      const { data: res } = await this.$http.get(url)
      if (res.code === 200) {
        item.isHidden = true
        this.list = this.list.filter(i => i.itemId !== item.itemId)
        // 恢复滚动位置
        //  window.scrollTo(0, scrollTop);
      }
    },
    async updatePrice () {
      const url = 'duozhuayu/order/update'
      const { data: res } = await this.$http.post(url, this.currentItem)
      this.$toast(res.msg)
    },
    async myOrderRecord () {
      const { data: res } = await this.$http.post('duozhuayu/order/list', this.form)
      console.log(res)
      this.order_num = res.count
      this.order_list = res.data
    },
    change () {
      this.form.page_no = 0
      this.list = []
      this.onLoad()
    }
  },
  components: {}
}
</script>

<style lang="less" scoped>
.van-tag {
  margin-left: 5px;
}

.li {
  display: flex;
  width: 100%;
  margin-bottom: 22.4px;
  position: relative;
  overflow: hidden;

  a {
    display: block;
    width: 100%;
    height: 100%;

    .list-img {
      float: left;
      width: 89.6px;
      height: 89.6px;
      text-align: center;
      line-height: 89.6px;
      font-size: 0;
      border: 1px solid #f3f3f3;
      border-radius: 4.48px;
      overflow: hidden;
      margin-right: 16.8px;

      img {
        max-width: 100%;
        max-height: 100%;
        display: inline-block;
      }
    }
  }

  .list-con {
    float: left;
    position: relative;

    a {
      display: block;
      width: 100%;
      height: 100%;

      .title {
        width: 100%;
        line-height: 0.42*56px;
        font-size: 0.3*56px;
        margin-bottom: 0.15*56px;
        color: #262626;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .price-box {
        font-size: 0.24*56px;
        color: #9e100e;
        margin-bottom: 0.14*56px;

        .price {
          font-size: 0.34*56px;
          margin-right: 0.1*56px;
          font-weight: 700;
        }

        .appearance {
          display: inline-block;
          padding: .003*56px 0.1*56px;
          background: #fafafa;
          border-radius: 0.08*56px;
          font-size: 0.22*56px;
          color: #999;
          margin-right: 0.1*56px;
        }
      }
    }
  }

  /* 指定店铺的卡片高亮背景 */
  .van-card--highlight {
    background-color: #fff8e6;
    border-radius: 8px;
  }
}
</style>
